{
    "subscriptions": "No subscriptions available.",
    "cost_centers": "No cost centers 1 available.",
    "employees": "No employees available.",
    "vendors": "No vendors available.",
    "budgets": "No budgets available.",
    "approvals": "No approvals available.",
    "expense_data": "No expense data available.",
    "limits": "No limits available.",
    "company_data": "No company data added yet.",
    "not_available": "Not available",
    "no_data": "No data",
    "no_bank_accounts": "No bank accounts connected yet.",
    "no_expense_accounts": "No expense accounts added yet.",
    "no_expense_accounts_yet": "No expense accounts yet.",
    "no_cost_center_2": "No cost center 2 added yet.",
    "no_cost_center_2_yet": "No cost center 2 yet.",
    "no_payment_data": "No payment data added yet.",
    "select_option_no_value": "-",
    "employee": {
        "superior": "No superior set"
    },
    "banking": {
        "no_banks_found": "No banks found that match the search.",
        "bank_connection": "You should have a connected bank account to be able to execute a transfer."
    },
    "request": {
        "expense_account": "No expense account set",
        "cost_center_2": "No cost center 2 set",
        "cost_center_1": "No cost center 1 set"
    },
    "transactions": {
        "possible_expenses": "No expenses found to match.",
        "matched_expenses": "No expenses matched yet."
    },
    "cards": {
        "no_cards": "No cards issued yet.",
        "no_transactions": "No transactions yet.",
        "no_phone_number": "This card has no phone number attached."
    },
    "inbox_invoice": {
        "no_docs_needed_expenses": "There are currently no expenses that need documents. You can also create a new invoice request for this invoice by clicking the button below.",
        "no_invoices_in_inbox": "There are currently no invoices in your inbox."
    },
    "no_tax": "No VAT data added yet.",
    "no_tax_yet": "No VAT data yet.",
    "no_team": "No team data added yet.",
    "no_team_yet": "No team data yet.",
    "no_forecast_rules": "No forecast rule yet.",
    "transaction_category": "Un-categorized",
    "no_imports_yet": "No imports yet.",
    "no_export_history": "No export history yet."
}
